export const Anomalies = [
  {
    "categories": ["V"],
    "name": "2-Pop",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "2-Pop Error",
    "description": "2-pop in the header is against spec or incorrect. i.e. video pop is in the incorrect location, is present when not requested, is not present when requested"
  },
  {
    "categories": ["V"],
    "name": "3D Ghosting",
    "description": "A convergence error causing a doubled image or halo effect"
  },
  {
    "categories": ["V"],
    "name": "3D Window",
    "description": "An object in negative 3D space does not align correctly on the edge of the frame, causing an uncomfortable split edge. Also could be an issue with a floating window created to address a negative space 3D issue."
  },
  {
    "categories": ["A"],
    "name": "Abrupt Level Change",
    "description": "Abrupt change in the base or peak audio levels unintentionally or non-diegetically."
  },
  {
    "categories": ["A"],
    "name": "ADR Error",
    "description": "A line of dialog does not sound natural coming from the on screen action or match the lip movement, likely a problem with the ADR recording or mixing. If ADR event is simply out of sync, please use \"Out-of-sync\""
  },
  {
    "categories": ["V"],
    "name": "Aliasing/Stepping",
    "description": "Undesirable “beating” effects caused by sampling frequencies being too low to faithfully reproduce image detail. Looks like distortion or artifact that results when the signal reconstructed from samples is different than the original image. Often occurs at the edges of text graphics. "
  },
  {
    "categories": ["V"],
    "name": "Animation Error",
    "description": "For animated content, an object collides and intersects with the physical space of a second object, creating an unnatural overlap. "
  },
  {
    "categories": ["V"],
    "name": "Artifacting",
    "description": "A generic term for a visible defect in the video usually due to digital processing. "
  },
  {
    "categories": ["V"],
    "name": "Aspect Ratio",
    "description": "Aspect ratio of the image does not meet specification in platform requirements."
  },
  {
    "categories": ["V"],
    "name": "Aspect Ratio Mismatch",
    "description": "shot is in a different aspect ratio than rest of featured content"
  },
  {
    "categories": ["A"],
    "name": "Audio Click/Pop/Tick/Snat",
    "description": "An out of place pop, click or tick on the soundtrack, could be from bad digital processing, a bad splice, weak signal, microphone noise, or any number of other causes."
  },
  {
    "categories": ["A"],
    "name": "Audio Dropout",
    "description": "Audio levels drops below 60 db or is inaudible for a short or long period of time, where audio is expected to be present. Verify by checking source content and confirming on audiometers."
  },
  {
    "categories": ["A"],
    "name": "Average Loudness",
    "description": "This is an overall calculation of the average sound pressure level of the track, that the LUFS/LKFS analysis is within the spec of the format specification."
  },
  {
    "categories": ["V"],
    "name": "Bad Channel Conditions (Concealment Error)",
    "description": "Occurs when the tape stock is bad. Appears as digital hit(s) on the screen, but it doesn't always play back in the exactly the same way (not frame accurate). Could be one frame or several seconds. Always check the tape on multiple decks to confirm it's not deck specific. Tape deck will log condition errors in its error log during playback."
  },
  {
    "categories": ["F"],
    "name": "Bad Splice/Visible Splice",
    "description": "A cut in the film that is distorted, has visual break-up, or the images around the cut are misaligned, cropped or mixed with each other."
  },
  {
    "categories": ["V"],
    "name": "Banding",
    "description": "An artifact that appears in areas of a color gradients where the lack of sufficient color bit-depth causes noticeable bands instead of a smooth transition. "
  },
  {
    "categories": ["V"],
    "name": "Bars & Tone",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Bars & Tone Duration",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Bars Incorrect Range",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Black",
    "description": "Any Commercial Black, Technical Black or Technical Break"
  },
  {
    "categories": ["V"],
    "name": "Black Detail",
    "description": "There is lack of detail in the blacks, if the shadows are significantly clipped or crushed."
  },
  {
    "categories": ["V"],
    "name": "Black Duration",
    "description": "Any duration of a black not to spec"
  },
  {
    "categories": ["V"],
    "name": "Black Levels (Crushed)",
    "description": "The black levels of the video image are significantly crushed or clipped, with a flat line at the bottom of the video scope accompanied by a loss of visual detail in the shadows. "
  },
  {
    "categories": ["V"],
    "name": "Black Levels (Lifted)",
    "description": "The black levels of the video image are significantly lifted above 10 IRE, raising the shadow areas of the image to a milky black that never truly touches true zero black"
  },
  {
    "categories": ["V"],
    "name": "Black Levels (Out-of-range)",
    "description": "The black levels of the video image fall below the correct video range for the technical specification, such as super-blacks below 0 IRE"
  },
  {
    "categories": ["V"],
    "name": "Borders",
    "description": "Artwork contains uncropped borders."
  },
  {
    "categories": ["A"],
    "name": "Bump",
    "description": "Extraneous sound that does not sound natural in context"
  },
  {
    "categories": ["V"],
    "name": "CTT/Annotation",
    "description": "DCP: Incorrect Content Title Text or Annotation"
  },
  {
    "categories": ["V"],
    "name": "Call To Action",
    "description": "Image contains release dates, timeframes or information regarding alternate distribution platforms."
  },
  {
    "categories": ["V"],
    "name": "Camera Bump/Jitter",
    "description": "The shot framing moves unnaturally likely due to the camera getting bumped or shaking"
  },
  {
    "categories": ["F"],
    "name": "Cell Dirt",
    "description": "Dirt and dust that have settled on the cells and change as the cels are photographed in sequence, resulting in stop motion animation of dirt and dust. Unique to cell animation. Example: Mickey Mouse Shorts, Fantasia."
  },
  {
    "categories": ["A"],
    "name": "Censorship",
    "description": "The audio contains language that should not be present per the censorship rules"
  },
  {
    "categories": ["A"],
    "name": "Channel Configuration",
    "description": "An audio element plays through the wrong audio channel or track than expected"
  },
  {
    "categories": ["V"],
    "name": "Channel Identifiers",
    "description": ""
  },
  {
    "categories": ["F"],
    "name": "Chemical Stain",
    "description": "A type of film dirt that is caused by a chemical spill, developer stains, or improper washing in film processing tank. Appears like a transparent colored spots on image. Similar to looking at a cell through a microscope."
  },
  {
    "categories": ["V"],
    "name": "Chroma Bleed",
    "description": "The color of an object is saturated to the point that there is a loss of detail, edges are unnaturally defined or bleed into their surroundings. "
  },
  {
    "categories": ["V"],
    "name": "Chroma Key Noise",
    "description": "A specific colored area or the edges around an object are unnaturally noisy, due to a potential chroma key error. "
  },
  {
    "categories": ["A"],
    "name": "Clipping",
    "description": "Increased audio levels exceeding the technical spec for the format, causing flat-lining of the audio peaks, distortion or clicking. Could be clipped at 0db or also clipped lower due to a problem with a source file."
  },
  {
    "categories": ["A"],
    "name": "Clipping/Distortion",
    "description": "Increased audio levels, flat-lining, distortion or clicking. Could be clipped at 0db or also clipped lower due to source distortion."
  },
  {
    "categories": null,
    "name": "Cold Open",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Color",
    "description": "Subtitle font color is against spec.  (ie.  white for 2D, yellow for 3D)."
  },
  {
    "categories": ["V"],
    "name": "Color Error",
    "description": "An unnatural coloration to all or part of the frame, or a single object"
  },
  {
    "categories": ["V"],
    "name": "Color Mismatch",
    "description": "The video insert does not match the color grade of the material it replaces, or does not match the shots before and after the insert."
  },
  {
    "categories": ["V"],
    "name": "Compositing Error",
    "description": "The edges, matte lines or combination of two elements has issues related to the VFX compositing process"
  },
  {
    "categories": ["V"],
    "name": "Compositing Noise",
    "description": "A specific area or the edges around a text overlay are unnaturally noisy"
  },
  {
    "categories": ["V"],
    "name": "Compression Artifact",
    "description": "When possible please categorize under the specific compression error type, i.e. Mosquito Noise, Macroblocking, etc"
  },
  {
    "categories": ["V"],
    "name": "Content Guidelines",
    "description": "Metadata value contains semantic error."
  },
  {
    "categories": null,
    "name": "Continuity Error",
    "description": "An inconsistency in the physical placement or characteristics of a person or object between two or more shots. Can also apply to inconsistencies in dialog/plot points."
  },
  {
    "categories": ["V"],
    "name": "Corrupt Frame",
    "description": "Missing partial data from image. A portion of the frame shows part of the image from an entirely separate frame or even partial image break-up. "
  },
  {
    "categories": null,
    "name": "Credits Alt. End",
    "description": "End credits of the program, but an alternate version done by the producer. This is usually found in a file after main program and before or after textless inserts."
  },
  {
    "categories": null,
    "name": "Credits Alt. Open",
    "description": "Opening credits typically after the main title sequence in a program. This could also be an alternate main title sequence. This is usually found in a file after main program and before or after textless inserts."
  },
  {
    "categories": null,
    "name": "Credits End",
    "description": "End credits of the program."
  },
  {
    "categories": null,
    "name": "Credits Open",
    "description": "Opening credits typically after the main title sequence in a program. Ending with directed by or written by most of the time."
  },
  {
    "categories": ["V"],
    "name": "Cropped Incorrectly",
    "description": "Relevant information has been cropped from the image."
  },
  {
    "categories": ["F"],
    "name": "DRS error",
    "description": "When an artifact or error was created through the process of cleaning and repairing dirt, dust or scratches on the film. "
  },
  {
    "categories": ["A"],
    "name": "Dbox Error",
    "description": "Dbox not functioning properly: not running, stops mid program, mistimed to picture, etc."
  },
  {
    "categories": ["A"],
    "name": "Dbox Missing",
    "description": "Dbox is not present when it is specified to be there"
  },
  {
    "categories": ["V"],
    "name": "Dead/Stuck Pixel",
    "description": "A fixed pixel (or a couple pixels) that could be black, white, or discolored remains stuck on screen for most or all of the shot"
  },
  {
    "categories": ["V"],
    "name": "Density Shift",
    "description": "A shift in the overall hue or luminance in the middle of a shot or between similar-looking shots. Sometimes called a Chroma shift"
  },
  {
    "categories": ["A"],
    "name": "Dialog on M&E",
    "description": "Music & Effects tracks should not contain any audible, identifiable dialog. Sometimes may be approved in circumstances where dialog is universal, such as aliens, foreign character that won't change."
  },
  {
    "categories": ["V"],
    "name": "Digital Hit",
    "description": "Discolored or brightly colored squares or thin lines which can occur for one or multiple frames. Large pixel hits can also be classified as 'Digital Hits'"
  },
  {
    "categories": ["F"],
    "name": "Dirt",
    "description": "For B&W and Color negative: Dirt on the film appears as white or black spots. For films using successive exposure and YCM 3-strip Technicolor, dirt could also appear as spots of Red, green and/or blue."
  },
  {
    "categories": ["A"],
    "name": "Distortion",
    "description": "Overloaded audio levels, causing distortion of the signal and loss of clarity. Could be peaking at 0db or also distorted lower due to a source issue."
  },
  {
    "categories": ["V"],
    "name": "Duration/Timing",
    "description": "Text event appears mistimed or appears for too long/short of a duration"
  },
  {
    "categories": ["A"],
    "name": "Echo/Reverb",
    "description": "A distracting or out of place audio echo or reverberation of the sound repeating or reflecting back on itself, or changes in the middle of a scene where expected to be consistent. Also could be a sound that is out of sync with the same sound that is mirrored on a different track. "
  },
  {
    "categories": ["V"],
    "name": "Edge Enhancement",
    "description": "Excessive sharpness of the edges of objects on the screen causing a Stair casing effect or an unnatural outline."
  },
  {
    "categories": ["V"],
    "name": "Edge Intrusion",
    "description": "A portion of a boom microphone, matte box or production equipment intrudes on the edge of frame for one or more frames."
  },
  {
    "categories": ["A"],
    "name": "Edit Error",
    "description": "An audio element is cut unnaturally, for example is clipped at the front or end of a word, effect or music"
  },
  {
    "categories": ["F"],
    "name": "Emulsion Stain",
    "description": "Stain from the emulsion used on film in the telecine process. A stain on the emulsion side of the film. Looks like a white blotch on image."
  },
  {
    "categories": null,
    "name": "Episodic Title",
    "description": ""
  },
  {
    "categories": ["A"],
    "name": "Extraneous Effect",
    "description": "An extra sound effect or noise that does not seem motivated by picture"
  },
  {
    "categories": ["V"],
    "name": "Fails to Import/Parse",
    "description": "Metadata has either incorrect format or is corrupt and will not load into system."
  },
  {
    "categories": ["V"],
    "name": "First Frame of Picture",
    "description": "The first frame of picture does not appear at correct time code per specification"
  },
  {
    "categories": ["V"],
    "name": "Fixed Pattern Noise",
    "description": "A grid-like or crosshatch pattern over the screen most noticeable during a pan or over a plain background. Often related to the noise properties of a digital camera sensor"
  },
  {
    "categories": ["V"],
    "name": "Flicker",
    "description": "All or part of the frame has a high frequency flicker, changing luminance or color"
  },
  {
    "categories": ["V"],
    "name": "Folder Structure",
    "description": "Package does not follow the folder structure defined in the delivery specifications"
  },
  {
    "categories": ["A"],
    "name": "Format",
    "description": "The audio tracks do not follow the specified bit depth and frequency. For example, 24 bit 48 KHz, or the incorrect mix is provided, such as 5.1 when 2.0 is requested."
  },
  {
    "categories": ["V"],
    "name": "Format Guidelines",
    "description": "Metadata value contains syntactic error."
  },
  {
    "categories": ["A"],
    "name": "Frame rate",
    "description": "Incorrect frame rate"
  },
  {
    "categories": ["V"],
    "name": "Framing Mismatch",
    "description": "The framing of the insert or textless material does not match the original framing of the material it replaces"
  },
  {
    "categories": ["V"],
    "name": "Framing Error/Matte Shift",
    "description": "One or more pixel width or height of black (or other color) that is on the outside of the frame edge or within the aspect ratio for matted content."
  },
  {
    "categories": ["V"],
    "name": "Freeze Frame",
    "description": "The picture freezes for 1 or many frames as the time code continues. Could be located at an edit or mid shot.  An exception would be in hand-drawn animation where the animated frame rate is less than the video frame rate."
  },
  {
    "categories": ["V"],
    "name": "Ghosting",
    "description": "Something moving in the foreground (usually a person) appears to be partially transparent and the background can be seen through them. Objects in motion could have a semi-transparent trail. If ghosting was created by a bad interlacing conversion, please use \"Interlacing Error.\""
  },
  {
    "categories": ["V"],
    "name": "Graphic Overlay",
    "description": "A graphic element appears as a semi-transparent overlay in an unexpected place. "
  },
  {
    "categories": ["V"],
    "name": "Green Band",
    "description": "DCP: Green Band include in Canadian DCP"
  },
  {
    "categories": ["V"],
    "name": "Green Screen Error",
    "description": "In a composited shot that uses a green screen (or similar background key), the foreground object temporarily disappears behind the background, often due to quick motion or soft edges such as hair. "
  },
  {
    "categories": ["F"],
    "name": "Hair",
    "description": "Film Hair; Strands of hair or dust particle which have been optically printed into the film element. Usually seen at the top or bottom of the screen. An actual hair that was caught in the film camera. This could last throughout or a piece of dirt that looks like a hair. "
  },
  {
    "categories": ["A"],
    "name": "Humor",
    "description": "Narration contains an attempt at humor that shouldn't be there"
  },
  {
    "categories": ["V"],
    "name": "Illegal Characters",
    "description": "Timed Text contains characters that cannot be interpreted or rendered by the platform."
  },
  {
    "categories": ["A"],
    "name": "Inaccurate",
    "description": "Narration does not accurately describe what is depicted on screen"
  },
  {
    "categories": ["V"],
    "name": "Inaccurate Slate",
    "description": "Slate contains inaccurate information or spelling mistakes"
  },
  {
    "categories": ["V"],
    "name": "Incomplete Localization",
    "description": "All or parts of Metadata are not translated into language of country/region."
  },
  {
    "categories": ["A"],
    "name": "Incorrect Audio",
    "description": "The audio does not match the picture. This is an editing issue not a sync issue. Could also be the incorrect language"
  },
  {
    "categories": ["V"],
    "name": "Incorrect Bars",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Incorrect Character Set",
    "description": "Timed Text character sets are incorrect for a given language."
  },
  {
    "categories": ["A"],
    "name": "Incorrect Dub Vocals",
    "description": "Dubbed vocals do not match the DCVI Vocal Sheet -- either in body of program or in the  end credits"
  },
  {
    "categories": ["V"],
    "name": "Incorrect Genre",
    "description": "Genre in Metadata does not match actual content of program."
  },
  {
    "categories": ["V"],
    "name": "Incorrect Insert",
    "description": "The video insert is not the correct version according to the documentation or specification"
  },
  {
    "categories": ["V"],
    "name": "Incorrect Logo",
    "description": "Logo order is incorrect or incorrect logo was used"
  },
  {
    "categories": ["V"],
    "name": "Incorrect Product Hierarchy",
    "description": "Product(s) not tied the proper version or \"umbrella\" intellectual property. Issue exists with parent/child hierarchy (e.g., TV Episode included in the wrong season)."
  },
  {
    "categories": ["V"],
    "name": "Incorrect Rating",
    "description": "Film or TV ratings do not match the country/region rating system."
  },
  {
    "categories": ["V"],
    "name": "Incorrect Resolution",
    "description": "Resolution"
  },
  {
    "categories": ["V"],
    "name": "Incorrect Talent Information",
    "description": "The talent listed in Metadata does not correspond to the program or feature."
  },
  {
    "categories": ["V"],
    "name": "Incorrect Text/Event",
    "description": "Incorrect text (Example: character's name is Tom, but Text says \"Betsy,\" \"Thom\" or \"Don\"),"
  },
  {
    "categories": ["V"],
    "name": "Interlacing Error",
    "description": "This occurs during a frame rate conversion, by adding frames and causing movement on each field. This can appear like an inconsistent comb pattern on the edge of moving objects, affecting the smoothness of the motion. "
  },
  {
    "categories": ["V"],
    "name": "Invalid Avails Reference",
    "description": "Delivery Package has missing or incomplete mapping from Avails to content."
  },
  {
    "categories": ["V"],
    "name": "Invalid Content Structure",
    "description": "Content structure is missing, incomplete or incorrect."
  },
  {
    "categories": ["V"],
    "name": "Invalid Genre",
    "description": "Metadata contains genre value not supported by platform."
  },
  {
    "categories": ["V"],
    "name": "Invalid Inventory",
    "description": "List of assets is incorrect, not including “Referenced Asset” issues."
  },
  {
    "categories": ["V"],
    "name": "Invalid Presentation",
    "description": "List of tracks that play together is incomplete or incorrect."
  },
  {
    "categories": ["V"],
    "name": "Jump Cuts",
    "description": "A skipping of frames, that causes an unnatural movement on screen."
  },
  {
    "categories": ["V"],
    "name": "KDM Folder",
    "description": "DCP: KDM Folder missing items such as CPL, Wailua and CPL info file"
  },
  {
    "categories": ["V"],
    "name": "KDM in Package",
    "description": "DCP: KDM files should not be included in the Package folder"
  },
  {
    "categories": ["V"],
    "name": "Keystone Distortion",
    "description": "A geometric distortion resulting when a rectangular plane is projected or photographed at an angle not perpendicular to the axis of the lens. The result is that the rectangle becomes trapezoidal."
  },
  {
    "categories": ["A"],
    "name": "Legal Exclusion",
    "description": "Contains words that have been excluded for use by Legal or the creative letter, such as curse words, inappropriate language, singing, trademarked terms, or language that disparages the Disney brand."
  },
  {
    "categories": ["V"],
    "name": "Lens Glare/Flare",
    "description": "Sunlight hitting the camera lens either directly or indirectly causes the picture to become washed out, lack contrast, or show lightened or colored shapes"
  },
  {
    "categories": ["F"],
    "name": "Light Leak",
    "description": "When light leaks through the side of the camera lens causing a section or the whole image appear to be washed out or a fluctuating rhythmic discoloration and exposure issue on the side of the frame."
  },
  {
    "categories": ["V"],
    "name": "Line Dropout",
    "description": "A line of distortion, color, black or white that goes horizontally or vertically across the screen, partial or full width. "
  },
  {
    "categories": ["V"],
    "name": "Line Length",
    "description": "Length of line(s) in Timed Text events exceeds specification in platform requirements."
  },
  {
    "categories": null,
    "name": "Logo(s)",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Luminance Banding",
    "description": "Looks like a moving misty/hazy-ness over the screen. Usually occurs over already grainy footage."
  },
  {
    "categories": ["V"],
    "name": "Macro-blocking",
    "description": "Instead of looking smooth, the video looks as though it is made of blocks. Areas of similar color & luminance are gathered together into blocky chunks. "
  },
  {
    "categories": null,
    "name": "Main Title",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Mis-matched Mouth Movement",
    "description": "An actor's head, jaw or facial movements do not match the audible dialog, often seen with over-the-shoulder shots where the speaking actor is facing away from camera"
  },
  {
    "categories": ["V"],
    "name": "Missing Bars",
    "description": ""
  },
  {
    "categories": ["A"],
    "name": "Missing Dialog",
    "description": "Words from the dialog are missing when compared to picture, or when compared to the original language master if listening to a foreign language dub."
  },
  {
    "categories": ["A"],
    "name": "Missing Effect",
    "description": "A sound effect is missing when compared to picture, or when compared to the original Printmaster if listening to the Music & Effects (M&E) track. M&E tracks should be fully filled. Could include missing hand pats, cloth rustle, etc."
  },
  {
    "categories": ["V"],
    "name": "Missing Media",
    "description": "\"No Data\" Frames appear within in picture, or “offline media” graphic generated by an editing system found it’s way into the video."
  },
  {
    "categories": ["V"],
    "name": "Missing Regional Film Certificate",
    "description": "Film Certificates are not present for a country/region that requires them."
  },
  {
    "categories": ["V"],
    "name": "Missing Required Information",
    "description": "Metadata is incomplete or certain tags/fields are blank."
  },
  {
    "categories": ["V"],
    "name": "Missing Slate",
    "description": "Slate at the head of content is required by spec but isn't there"
  },
  {
    "categories": ["V"],
    "name": "Missing Territory Required Elements",
    "description": "Missing Territory Required Components; Example; Japan requires Eiren Mark, Russia requires Russian Rating Cards, China requires Dragon card & official approval"
  },
  {
    "categories": ["V"],
    "name": "Missing Text/Event",
    "description": "There is no corresponding subtitle event for audio and/or audio descriptive text such as \"music playing\" during extended non dialog scenes or End Credits"
  },
  {
    "categories": ["V"],
    "name": "Missing Tone",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Missing Track",
    "description": "The captions track is missing or does not display"
  },
  {
    "categories": ["V"],
    "name": "Missing Verification",
    "description": "DCP: Wailua Verification Report missing"
  },
  {
    "categories": ["A"],
    "name": "Missing Vocals/Music",
    "description": "The music as part of the underscore or song has elements missing, instrumental or vocal"
  },
  {
    "categories": ["F"],
    "name": "Mistime",
    "description": "A brief one frame horizontal flash that can be seen at the top or bottom of the first or last frame of a shot."
  },
  {
    "categories": ["A"],
    "name": "Mix Bleed",
    "description": "Poor quality due to Narration containing composite mix bleed through"
  },
  {
    "categories": ["A"],
    "name": "Mix/Balance",
    "description": "General issue in the mix, does not sound as expected, either from the balance of volume on certain channels, or that elements are not able to be heard clearly as expected, such as dialog. Could refer both to volume and imaging (pan). For example left channel is louder than the right channel"
  },
  {
    "categories": ["V"],
    "name": "Moiré",
    "description": "Rainbow diagonal striping found most often on small detailed cross patterns. ANOTHER DESCRIPTION: Fringes are an interference pattern that is formed when two similar grid-like patterns are superimposed. They create a pattern of their own that does not exist in either of the originals. The result is a series of fringe patterns that change shape when as the grids are moved relative to each other"
  },
  {
    "categories": ["A"],
    "name": "Mono-summed",
    "description": "Two audio tracks, such as stereo pairs are identical, creating a monaural effect rather than a true stereo spectrum. Two tracks are completely in phase when they should be stereo."
  },
  {
    "categories": ["V"],
    "name": "Mosquito noise",
    "description": "The pixels look like they are moving around – like mosquitoes, around sharp edges of objects such as text, due to video compression."
  },
  {
    "categories": ["V"],
    "name": "Motion Lag",
    "description": "A faint, blurry trail behind whatever is moving. Due to a conversion error, noise reduction, or a frame-blending approach to a digital speed change. "
  },
  {
    "categories": ["A"],
    "name": "Music with Lyrics",
    "description": "A song is playing in the background or sung by characters that should be flagged for rights clearance."
  },
  {
    "categories": ["V"],
    "name": "Naming Convention",
    "description": "File name is not to spec or does not match contents"
  },
  {
    "categories": ["F"],
    "name": "Noise/Grain",
    "description": "The amount of grain inherent in the film source is excessive.  Small particles cover image that reduces picture definition."
  },
  {
    "categories": ["V"],
    "name": "Noise/Grain/Activity",
    "description": "The image contains a high contrast, grainy noise pattern, more than what is normal for a film or video source. "
  },
  {
    "categories": ["A","V"],
    "name": "Non-Subtitled",
    "description": "Dialog non-subtitled material"
  },
  {
    "categories": ["V"],
    "name": "Not Localized",
    "description": "Printed text in Artwork is not the correct language for the intended territory."
  },
  {
    "categories": ["V"],
    "name": "Not Suitable for All Ages",
    "description": "Content of image is not appropriate for all audiences."
  },
  {
    "categories": ["V"],
    "name": "Number of Lines",
    "description": "Number of lines in Timed Text events exceeds specification in platform requirements."
  },
  {
    "categories": ["A"],
    "name": "Off-Speed/Drift",
    "description": "The speed of the audio does not match the specifications of the video, for example 23.976 when 24 fps is requested. The audio drifts over time consistently becoming earlier or later than picture. Time code on sources does not lock."
  },
  {
    "categories": ["V"],
    "name": "Out-of-Gamut",
    "description": "The color saturation levels in a video image cause a video scope to exceed the gamut limits of the SMPTE video spec (for the appropriate color space, such as BT.709). This could look like very saturated colors that clip near 100% on a vectorscope, with a loss of detail."
  },
  {
    "categories": ["A"],
    "name": "Out-of-Phase",
    "description": "An audio source present on two channels (or multi-channel), with the waveform is inverted. Would experience phase cancellation under certain listening environments, resulting in a thin/hollow sound and reduced volume."
  },
  {
    "categories": ["A"],
    "name": "Out-of-Sync",
    "description": "Audio event is out of sync with on-screen action (dialog, FX, music) Mastering Tolerance: Audio cannot be more than 1.0 frame ahead of picture or 1.5 frames behind picture. Deliverable Tolerance: Audio cannot be more than 2.0 frame ahead or behind picture"
  },
  {
    "categories": ["A","V"],
    "name": "Out-of-spec",
    "description": "Audio or video does not meet specified technical requirements"
  },
  {
    "categories": ["V"],
    "name": "Over Saturation",
    "description": "The color of an object is saturated to the point that there is a loss of detail, edges are unnaturally defined or bleed into their surroundings. "
  },
  {
    "categories": ["V"],
    "name": "Pan & Scan error",
    "description": "Can be caused by 'panning'  the opposite direction of the action and/or main character. “pan and scan” is a method of converting scope image to a 4:3 aspect ratio by re-composing the image and moving it left or right depending on the action."
  },
  {
    "categories": ["V"],
    "name": "Parent Reference",
    "description": "DCP: Parent OV is not properly referenced"
  },
  {
    "categories": ["V"],
    "name": "Peak Levels (Clamped)",
    "description": "The peak/white levels of the video image are significantly “clamped” consistently lower than 90 IRE. Visual elements that should be full 100% white consistently are clamped at 90% or lower.  "
  },
  {
    "categories": ["V"],
    "name": "Peak Levels (Clipped)",
    "description": "The peak/white levels of the video image are above spec (i.e. over 100 IRE), or are significantly “clamped” much lower than 100 IRE, or are “clipped,” meaning a flat line at the top of the video scope accompanied by a loss of visual detail in the highlights.  "
  },
  {
    "categories": ["V"],
    "name": "Peak Levels (Over)",
    "description": "The peak/white levels of the video image are above the spec requirement (i.e. over 100 IRE), causing a loss of visual detail in the highlights.  Often the result of overexposure and usually happens in bright areas that have “blown-out highlights.” "
  },
  {
    "categories": ["A"],
    "name": "Peak Loudness",
    "description": "The audio peak level throughout the track does not match the format specification (ex. +20 Near Field or +12 Full Range)"
  },
  {
    "categories": ["A"],
    "name": "Peak/Out-of-Range",
    "description": "The audio peak level of an event or effect exceeds the format specification (for overall compression R128 issues, please select Range/Compression)"
  },
  {
    "categories": ["V"],
    "name": "Pixel Error",
    "description": "A white or out of place pixel for 1-2 frames"
  },
  {
    "categories": ["V"],
    "name": "Pixel Flurry",
    "description": "A type of VFX render error in which a cloud of pixels shows around an object"
  },
  {
    "categories": ["V"],
    "name": "Pixel Hit",
    "description": "A flashed dead pixel (white, black, discolored) appears for one or a few frames on the image, larger pixel hits should be categorized as a digital hit."
  },
  {
    "categories": ["V"],
    "name": "Pixelation",
    "description": "The display of large, blocky pixels in an image caused by over-enlarging it."
  },
  {
    "categories": ["V"],
    "name": "Pixelation/Blurry",
    "description": "Image source is low quality."
  },
  {
    "categories": ["V"],
    "name": "Placement",
    "description": "Subtitle is placed in such a way it is covering a character's face, or is placed in such a way that is outside of title safe or in awkward location"
  },
  {
    "categories": ["A"],
    "name": "Poor Quality",
    "description": "Audio quality is not crisp and clear, but muddied, garbled, or subject to distortion or generation loss which creates a poor listening experience."
  },
  {
    "categories": ["A","V"],
    "name": "Possible S&P Issue",
    "description": "An event that has moral, ethical, and/or legal implications in the program which must be approved by the network's Standards and Practices team."
  },
  {
    "categories": ["V"],
    "name": "Posterization",
    "description": "Posterization occurs when an area of smooth color transitions into a shifted abrupt sequential transition. The effect produced when an image is displayed with less resolution than what is needed to make the image complete.\nSimilar to banding but posterization can be a random shape. "
  },
  {
    "categories": ["V"],
    "name": "Power Window",
    "description": "An unnatural shape or cut-out related to the DI color correction process is visible"
  },
  {
    "categories": ["V"],
    "name": "Production Crew",
    "description": "Visible production crew members within the frame or seen in a reflective surface."
  },
  {
    "categories": ["V"],
    "name": "Production Equipment",
    "description": "Visible production equipment within the frame or seen in a reflective surface."
  },
  {
    "categories": ["V"],
    "name": "Production Mark",
    "description": "There is a visible production mark, for example a visual effects tracking mark, or colored tape marks on the ground for actor or object placement"
  },
  {
    "categories": ["A"],
    "name": "Production Noise",
    "description": "Audio track contains extraneous noises created on set by the production staff (example \"Action\" \"Cut\"). Could also include orchestra noise, production background noise, camera noise or generator hum."
  },
  {
    "categories": null,
    "name": "Program End",
    "description": "End of the program"
  },
  {
    "categories": null,
    "name": "Program Material",
    "description": ""
  },
  {
    "categories": null,
    "name": "Program Start",
    "description": "Start of the program"
  },
  {
    "categories": ["A"],
    "name": "Range/Compression",
    "description": "Audio tracks that are expected to be full range are limited range, for example R128 mix (for example, +12 when +20 is expected), or the opposite which has audio peaking higher than expected for the format (+20 when +12 is expected)"
  },
  {
    "categories": null,
    "name": "Recap",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Redundant Text/Event",
    "description": "The text overlay is redundant to the on-screen text already appearing in the picture."
  },
  {
    "categories": ["F"],
    "name": "Reel Marker",
    "description": "Circular marker on the upper right hand corner of the film that delineates the end of a reel. Also called a cigarette burn. Appears at 8 seconds and 1 second before the end of a reel, marked on 4 consecutive frames"
  },
  {
    "categories": ["A","V"],
    "name": "Reference Point",
    "description": "Catch-all for events that help track edits like: coincidence point, 1st line of dialog, dialog sync, and effects sync."
  },
  {
    "categories": ["V"],
    "name": "Referenced Asset Invalid Type",
    "description": "One or more referenced assets are not an expected file type per the specification in platform requirements."
  },
  {
    "categories": ["V"],
    "name": "Referenced Asset Missing",
    "description": "One or more referenced assets are not available for ingest (e.g., needed asset was not provided). This could include dead URLs or other broken file references."
  },
  {
    "categories": ["V"],
    "name": "Referenced Asset Type Mismatch",
    "description": "File type of a referenced source asset is inconsistent with the type referenced (e.g., audio file referenced as a video file)."
  },
  {
    "categories": ["V"],
    "name": "Referenced Asset Unneeded",
    "description": "One or more assets are referenced but are not needed (e.g., track included that is not referenced elsewhere)."
  },
  {
    "categories": ["V"],
    "name": "References Incorrect Program Material",
    "description": "Metadata does not match corresponding video (e.g., title, description, file name, etc.)."
  },
  {
    "categories": ["V"],
    "name": "Render Error",
    "description": "Miscellaneous anomaly created by a failure in the render process"
  },
  {
    "categories": ["V"],
    "name": "Resolution",
    "description": "Resolution of Artwork does not meet specification in platform requirements."
  },
  {
    "categories": ["V"],
    "name": "Ringing",
    "description": "Bright, saturated colors or colored patterns are causing a pulsing or buzzing type of video noise around it."
  },
  {
    "categories": ["V"],
    "name": "Rolling Shutter",
    "description": "Due to a slow refresh rate on a digital production camera, the picture when moving quickly will display a jello warping effect, causing objects to slant unnaturally for a moment"
  },
  {
    "categories": ["A","V"],
    "name": "S&P Fix",
    "description": "Intentional edit to an event that has moral, ethical, and/or legal implications in the program and was approved by the network's Standards and Practices team."
  },
  {
    "categories": ["A"],
    "name": "Scratch",
    "description": "An unexplained audio anomaly, could be an out of place ripping noise in the audio track, generally refers to a result of an analog recording issue or a transfer from an older legacy optical soundtrack source."
  },
  {
    "categories": ["F"],
    "name": "Scratches",
    "description": "A thin line, horizontal or vertical, in the picture. Can last for one frame or an entire reel of film.  Scratches may appear black, white or colored, depending on which side of the film is scratched and how deep the scratches is. Possible causes are bad rollers on the Rank Cintel or film cleaner, mis threading of the film or debris embedded in the capstan."
  },
  {
    "categories": null,
    "name": "Segment",
    "description": "Program segment"
  },
  {
    "categories": ["V"],
    "name": "Shading/Vignetting",
    "description": "The edges of the frame or an object have an unnatural dark shading or vignetting effect along the corners of the image"
  },
  {
    "categories": ["A"],
    "name": "Shift",
    "description": "The audio has an abrupt shift in volume or imaging (pan) unmotivated by picture."
  },
  {
    "categories": ["V"],
    "name": "Slate",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Slate Duration",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Soft Focus",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Solarized Highlights",
    "description": "The white highlights of an image have color artifacting within them, for example the outside ring of a highlight is whiter than the inside of the highlight, inverted from what it should be. "
  },
  {
    "categories": ["V"],
    "name": "Spelling/Grammar/Punctuation",
    "description": "Misspelled words or misspelled proper name in burned-in text.  This is at least a Review, if not a Fail depending on the context. "
  },
  {
    "categories": ["F"],
    "name": "Spot",
    "description": "Spots that look like transparent water spots on the film, are usually source related issues"
  },
  {
    "categories": ["V"],
    "name": "Swapped Eyes",
    "description": "The left and right eyes are swapped, causing 3D issues"
  },
  {
    "categories": ["F"],
    "name": "Tear",
    "description": "An area of the film that has a \"tear-like\" appearance, often white, from a physical defect on the film."
  },
  {
    "categories": ["V"],
    "name": "Temporary VFX",
    "description": "A pre-vis or temporary visual effect made it into the final picture"
  },
  {
    "categories": ["V"],
    "name": "Text Misspelling",
    "description": "Misspelled words or misspelled proper name in burned-in text"
  },
  {
    "categories": ["V"],
    "name": "Text Over Black",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Text Over Picture",
    "description": ""
  },
  {
    "categories": ["A","V"],
    "name": "Textless Materials Incomplete",
    "description": "The textless reel does not contain all the textless material"
  },
  {
    "categories": ["A","V"],
    "name": "Textless Materials Incorrect",
    "description": "The textless reel has material that does not cover the texted events correctly, or may be the wrong material"
  },
  {
    "categories": ["A"],
    "name": "Thin/Tinny/Off-mike",
    "description": "Audio sounds like it's coming out of a tin can, could be from bad mike placement, excessive room reverb, a mix problem or out-of-phase audio."
  },
  {
    "categories": ["V"],
    "name": "Timing",
    "description": "Frame duration of localized versions should match OV"
  },
  {
    "categories": ["A"],
    "name": "Timing Conflict",
    "description": "Narration timing interferes with a character's dialog"
  },
  {
    "categories": ["V"],
    "name": "Title Mismatch",
    "description": "Title included in Artwork does not match title included in the Metadata."
  },
  {
    "categories": ["V"],
    "name": "Title Safe",
    "description": "Text/texted events/graphics are too close to the edges of the screen and are out of Title safe specifications. (SMPTE specification for HD is 90%)"
  },
  {
    "categories": ["V"],
    "name": "Tone Incorrect Range",
    "description": ""
  },
  {
    "categories": ["V"],
    "name": "Tone on MOS Channel",
    "description": ""
  },
  {
    "categories": ["A"],
    "name": "Track Contents",
    "description": "Track contains unexpected elements based on the configuration. For example production sounds identified on a dialog stem."
  },
  {
    "categories": ["A"],
    "name": "Track Order",
    "description": "The track order does not match the format specification (ex. L, R, C, LFE, LS, RS, LT, RT)"
  },
  {
    "categories": ["A"],
    "name": "Track Routing",
    "description": "The tracks are not routed to match the format specification"
  },
  {
    "categories": ["V"],
    "name": "Translation",
    "description": "The translation of the text does not correctly match the meaning of the audio."
  },
  {
    "categories": ["V"],
    "name": "Uncategorized",
    "description": "Any issue not covered by the standard terms and definitions."
  },
  {
    "categories": ["V"],
    "name": "VFX Error",
    "description": "For VFX/CGI content, an object collides and intersects with the physical space of a second object, creating an unnatural overlap. "
  },
  {
    "categories": ["V"],
    "name": "Video Range (Event)",
    "description": "The video has a Head/Full range conversion issue, such as over-whites or super-blacks outside the correct range, or is a lower contrast than the source."
  },
  {
    "categories": ["V"],
    "name": "Video Range (Track)",
    "description": "The video has a Head/Full range conversion issue, such as over-whites or super-blacks outside the correct range, or is a lower contrast than the source."
  },
  {
    "categories": ["V"],
    "name": "Visible Time code",
    "description": "The embedded time code is partially visible – either at the top or bottom of the frame."
  },
  {
    "categories": ["F"],
    "name": "Warp",
    "description": "At the cut point of spliced film, the shot warbles or appears visibly warped and/or distorted for a split second. This is usually found on older film stock and is caused by a poorly made cement splice in the negative joining two shots together."
  },
  {
    "categories": ["V"],
    "name": "Warping",
    "description": "The images is stretched or distorted unnaturally causing a warped look"
  },
  {
    "categories": ["A"],
    "name": "Wow/Pitch",
    "description": "The pitch of the audio bends up or down. Often related to an older analog tape format."
  },
  {
    "categories": ["V"],
    "name": "Z-Axis Placement",
    "description": "3D Subtitles only: The Z axis (depth) location of a subtitle interferes or collides with the underlying picture, or is placed behind a foreground object, or is generally in an incorrect location. Also known as \"Embedded.\""
  }
]



// WEBPACK FOOTER //
// ./src/app/workflows/anomalies.ts